"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SigningSessionStatus = exports.SigningRequestPurpose = exports.SigningRequestStatus = void 0;
var SigningRequestStatus;
(function (SigningRequestStatus) {
    SigningRequestStatus["Created"] = "CREATED";
    SigningRequestStatus["Pending"] = "PENDING";
    SigningRequestStatus["Completed"] = "COMPLETED";
    SigningRequestStatus["Failed"] = "FAILED";
    SigningRequestStatus["Cancelled"] = "CANCELLED";
})(SigningRequestStatus || (exports.SigningRequestStatus = SigningRequestStatus = {}));
var SigningRequestPurpose;
(function (SigningRequestPurpose) {
    SigningRequestPurpose["Psd2Consent"] = "PSD2_CONSENT";
    SigningRequestPurpose["Psd2Payment"] = "PSD2_PAYMENT";
    SigningRequestPurpose["BiometricAuthenticationActivation"] = "BIOMETRIC_AUTHENTICATION_ACTIVATION";
    SigningRequestPurpose["Other"] = "OTHER";
})(SigningRequestPurpose || (exports.SigningRequestPurpose = SigningRequestPurpose = {}));
var SigningSessionStatus;
(function (SigningSessionStatus) {
    SigningSessionStatus["Created"] = "CREATED";
    SigningSessionStatus["Started"] = "STARTED";
    SigningSessionStatus["Pending"] = "PENDING";
    SigningSessionStatus["Waiting"] = "WAITING";
    SigningSessionStatus["Completed"] = "COMPLETED";
    SigningSessionStatus["Failed"] = "FAILED";
    SigningSessionStatus["Cancelled"] = "CANCELLED";
})(SigningSessionStatus || (exports.SigningSessionStatus = SigningSessionStatus = {}));
